<template>
  <div v-if="detail">
    <div class="section-title">用户基础信息</div>
    <el-descriptions :column="2" border size="small" class="detail-block">
      <el-descriptions-item label="用户UID">{{ detail.userUid || '--' }}</el-descriptions-item>
      <el-descriptions-item label="用户类型">{{ detail.userTypeName || '--' }}</el-descriptions-item>
      <el-descriptions-item label="顶级合伙人UID">{{ detail.topPartnerUid || '--' }}</el-descriptions-item>
      <el-descriptions-item label="当前VIP等级">VIP{{ detail.currentVipLevel || 0 }}</el-descriptions-item>
    </el-descriptions>
    <div class="section-title">VIP{{ detail.applyVipLevel }}门槛信息</div>
    <el-table :data="detail.thresholds || []" border size="small" class="detail-block">
      <el-table-column prop="thresholdName" label="门槛类型" min-width="160" />
      <el-table-column label="门槛值" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.compareOperatorName || '>=' }} {{ amountText(scope.row.thresholdValue) }}{{ scope.row.unit ? ' ' + scope.row.unit : '' }}
        </template>
      </el-table-column>
      <el-table-column label="完成进度" min-width="180">
        <template slot-scope="scope">
          <span :class="scope.row.matched ? 'matched' : 'unmatched'">
            {{ amountText(scope.row.actualValue) }} / {{ amountText(scope.row.thresholdValue) }}{{ scope.row.unit ? ' ' + scope.row.unit : '' }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ApprovalDetail',
  props: {
    detail: Object,
  },
  methods: {
    amountText(value) {
      if (value === null || value === undefined || value === '') return '--';
      const text = String(value);
      return text.includes('.') ? text.replace(/\.?0+$/, '') : text;
    },
  },
};
</script>

<style scoped>
.section-title {
  margin: 14px 0 10px;
  font-weight: 600;
  color: #1f2f5f;
}
.detail-block {
  margin-bottom: 12px;
}
.matched {
  color: #19a35b;
}
.unmatched {
  color: #d93026;
}
</style>
